import { AdminRuntimeBackfillDecisionParams } from './adminRuntimeBackfillDecisions';

interface UseAdminRuntimeBackfillParams extends AdminRuntimeBackfillDecisionParams {}

export function useAdminRuntimeBackfill(params: UseAdminRuntimeBackfillParams) {
    void params;
}
